import { AlignJustify } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconAlignJustify12Line = createIcon(AlignJustify, 12, "Line");
export const IconAlignJustify16Line = createIcon(AlignJustify, 16, "Line");
export const IconAlignJustify20Line = createIcon(AlignJustify, 20, "Line");
export const IconAlignJustify24Line = createIcon(AlignJustify, 24, "Line");
export const IconAlignJustify32Line = createIcon(AlignJustify, 32, "Line");
export const IconAlignJustify48Line = createIcon(AlignJustify, 48, "Line");
export const IconAlignJustify64Line = createIcon(AlignJustify, 64, "Line");
